import type { ReactNode } from "react";
import { Link } from "react-router";

import { Logo } from "@/components/layout/Logo";

export function AuthShell({
  title,
  subtitle,
  footer,
  children,
}: {
  title: string;
  subtitle: string;
  footer: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-4 py-12">
      <Link className="text-ink" to="/">
        <Logo className="text-lg" />
      </Link>

      <div className="w-full max-w-sm rounded-panel border border-line bg-surface p-6 shadow-panel">
        <h1 className="text-xl font-semibold text-ink">{title}</h1>
        <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>
        <div className="mt-6">{children}</div>
      </div>

      <p className="text-sm text-ink-muted">{footer}</p>
    </div>
  );
}
